import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


export async function pdfGetDefaultAPI(){
    try {
        return await $authHost.get(API_ENDPOINTS.PDF + '/default');

    } catch (error: any) {
        return error;
    }
}

export async function pdfPutAPI(calculationId: string | number){
    try {
        return await $authHost.put(API_ENDPOINTS.PDF + '/calculation' + `/${calculationId}`);

    } catch (error: any) {
        return error;
    }
}

// Рендерит счёт и отдаёт его как blob для скачивания, НЕ сохраняя на сервере
// (номер счёта не выдаётся, счётчик не двигается, файл не пишется).
// stamp/sign = false — убрать печать/подпись из документа.
export async function pdfCalcDownloadAPI(
    calculationId: string | number,
    opts?: { stamp?: boolean, sign?: boolean },
){
    const qs: string[] = [];
    if (opts?.stamp === false) qs.push('stamp=0');
    if (opts?.sign === false) qs.push('sign=0');
    try {
        return await $authHost.get(
            API_ENDPOINTS.PDF + '/calculation' + `/${calculationId}/download` + (qs.length ? `?${qs.join('&')}` : ''),
            { responseType: 'blob' },
        );
    } catch (error: any) {
        return error;
    }
}

// PUT /pdf/settings — the backend merges whatever keys are sent over the stored
// settings, so a partial payload (e.g. just warningText / taglines / promo)
// leaves the other keys untouched.
export async function pdfSettingsUpdateAPI(data: any){
    try {
        return await $authHost.put(API_ENDPOINTS.PDF + '/settings', data);

    } catch (error: any) {
        return error;
    }
}

// Renders the invoice HTML from an *unsaved* settings object for the live
// preview. Returns { html }.
export async function pdfPreviewAPI(data: any){
    try {
        return await $authHost.post(API_ENDPOINTS.PDF + '/preview', data);

    } catch (error: any) {
        return error;
    }
}